module.exports = __webpack_public_path__ + "static/media/logo.72cd6b39.png";